import React, { useState, useEffect, FC, memo } from "../../../lib/teact/teact";
import Modal from "../../ui/Modal";
import LotSelect from "../ui/lotSelect";
import ChuyenTheoKhoang from "./catChuyen/chuyenTheoKhoang";
import './catChuyen/catChuyen.scss'
import ChuyenTuyChon from "./catChuyen/chuyenTuyChon";
import { catChuyenTheoKhoang, catChuyenTuyChon } from "./catChuyen/catchuyenlib";
import chuyenTheoKhoang from "./catChuyen/chuyenTheoKhoang";
import { isCuPhapMb, isCuPhapMn } from "../utils/common";
import worker from "../setupWorker";
// export type CatChuyenParams = {
//     loaiChuyenDi: 'STT' | 'TUYCHON';
//     catParamStt: { tu: number, den: number, phanTramHoacDiem: string };
//     dataCanChuyen:any;
// }

type OwnProps = {
    isOpen: boolean;
    textChuyen: string;
    onClose: () => void;
    onSmssReady: (params: string[]) => void;
    onPlayOne789: (params: any) => void;
    onPlayOne789TuyChon: (params: any) => void;
    dataCanChuyen: any;
    chuId: number;
}
interface State {
    chuyenDiType: ChuyenDiType;

}
type ChuyenDiType = 'KHOANG' | 'TUYCHON';
const CatChuyenDi: FC<OwnProps> = ({
    textChuyen, isOpen, onClose, dataCanChuyen, onSmssReady, chuId,
    onPlayOne789, onPlayOne789TuyChon
}) => {
    const [state, setState] = useState<State>({
        chuyenDiType: 'KHOANG',
        chuyenDiTu: 1,
        chuyenDiDen: 100,
        textChuyen: '',
    })
    function renderChuyenTheoKhoang() {
        return <ChuyenTheoKhoang chuId={chuId}
            onConfirm={onChuyenTheoKhoangconfirm}
            onPlayOn789={onPlayOne789confirm} />
    }
    function onChuyenTheoKhoangconfirm(params: any) {
        const [smss, mapResult] = catChuyenTheoKhoang(dataCanChuyen, params);
        if (smss.length > 0) {
            onSmssReady(smss);
        } else {
            worker.postMessage({ type: 'showsnackbar', data: 'Không có số liệu' });
        }
    }
    function onPlayOne789confirm(params: any) {
        const [smss, mapResult] = catChuyenTheoKhoang(dataCanChuyen, params);
        if (smss.length > 0) {
            onPlayOne789(mapResult);
        } else {
            worker.postMessage({ type: 'showsnackbar', data: 'Không có số liệu' });
        }
    }
    function onPlayOne789TuyCHonconfirm(params: any) {
        const [smss, mapResult] = catChuyenTuyChon(dataCanChuyen, params)
        if (smss.length > 0) {
            onPlayOne789TuyChon(mapResult);
        } else {
            worker.postMessage({ type: 'showsnackbar', data: 'Không có số liệu' });
        }
    }
    function renderChuyenTuyChon() {
        return <ChuyenTuyChon chuId={chuId} onConfirm={onChuyenTuyChonconfirm} onPlayOn789={onPlayOne789TuyCHonconfirm} />
    }
    function onChuyenTuyChonconfirm(parserResult: any) {
        const [smss, mapResult] = catChuyenTuyChon(dataCanChuyen, parserResult);
        if (smss.length > 0) {
            onSmssReady(smss);
        }
    }
    return (
        <Modal isOpen={isOpen} onClose={() => {
            onClose();

        }}
            title={'Chuyển đi nâng cao'}
            contentClassName="modal-content-customize"
            className="modal-main-customize"
            headerClassName="modal-full-width"
            hasCloseButton={true}

        >
            <>
                <LotSelect id="dialog-cat-select"
                    value={state.chuyenDiType}
                    onChange={(e) => {
                        const tmp = { ...state }
                        tmp.chuyenDiType = e.target.value as ChuyenDiType;
                        setState(tmp);
                    }
                    }>
                    <option value="KHOANG" selected={state.chuyenDiType == 'KHOANG'}>Chọn khoảng</option>
                    <option value="TUYCHON" selected={state.chuyenDiType == 'TUYCHON'}>Tùy chọn bộ số {isCuPhapMn() ? '(ghi rõ đài)' : ''}</option>
                </LotSelect>
                {
                    state.chuyenDiType == 'KHOANG'
                        ? renderChuyenTheoKhoang()
                        : renderChuyenTuyChon()
                }
            </>
        </Modal>
    )
}

export default memo(CatChuyenDi);